import "./Avatar.css"

export default function Avatar({ menuWeight }) {
    return (
        <div className="avatar">
            {menuWeight}lb
        </div>
    )
}